import React from "react";
import { Box } from "@mui/material";
import SFDateRangeSelector from "@/components/inputs/SFDateRangeSelector";
import { DOCLINK_COLORS } from "@/config/colors";
import {
  ADMIN_TOP_CARD_HEIGHT,
  adminDateRangePickerWideNestedSx,
} from "@/utils/adminTableStyles";

/** Same Syncfusion date-range chrome as Admin DocLink overview */
export const hubMedDocLinkDateRangeSx = {
  borderRadius: "8px",
  p: 1.5,
  minHeight: ADMIN_TOP_CARD_HEIGHT,
  height: ADMIN_TOP_CARD_HEIGHT,
  maxHeight: ADMIN_TOP_CARD_HEIGHT,
  boxSizing: "border-box",
  backgroundColor: DOCLINK_COLORS.DARK_PURPLE,
  display: "flex",
  flexDirection: "column",
  alignItems: "stretch",
  justifyContent: "center",
  gap: 0.5,
  overflow: "hidden",
  "& .text-black": { color: "white !important" },
  ...adminDateRangePickerWideNestedSx,
};

const HubMedAdminFilters = ({ dateStart, dateEnd, onDateRangeChange }) => (
  <Box sx={{ ...hubMedDocLinkDateRangeSx, flex: 1, minWidth: 0 }}>
    <SFDateRangeSelector
      adminToolbar
      value={[new Date(dateStart), new Date(dateEnd)]}
      onChange={(range) => {
        const start = range[0]?.toISOString().split("T")[0];
        const end = range[1]?.toISOString().split("T")[0];
        onDateRangeChange(start, end);
      }}
    />
  </Box>
);

export default HubMedAdminFilters;
